
import involvedPartiesApi from "@/services/api.involvedParties";
import { InvolvedParty } from "@/store/site-monitor/types";
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from 'vuex-class';

const SiteMonitor = namespace("siteMonitor");

@Component({})
export default class AnonymizeInvolvedParty extends Vue {
	@SiteMonitor.Action private loadInvolvedPartiesForEvent: (eventId: number) => Promise<void>;
	@SiteMonitor.Mutation private resetEventRecords: () => void;
	
	@Prop({type: Number, required: true})
	private involvedPartyId: number;
	
	@Prop({type: Number, required: true})
	private eventId: number;

	@Prop({type: String, required: true})
	private involvedPartyName: string;

	private isAnonymizationConfirmationVisible: boolean = false;
	private processingAnonymizeInvolvedParty: boolean = false;
	private ANONYMIZE_INVOLVED_PARTY_REGEX: RegExp = /\[Anonymized by [^\]]+\]/i;

	private get canAnonymize(): boolean {
		return this.ANONYMIZE_INVOLVED_PARTY_REGEX.test(this.involvedPartyName) == false;
	}
	private async triggerAnonymizeConfirmation(): Promise<void> {
		this.isAnonymizationConfirmationVisible = true;
	}

	private cancelAnonymize(): void {
		this.isAnonymizationConfirmationVisible = false;
		this.processingAnonymizeInvolvedParty = false;
	}

	private async anonymiseInvolvedParty(): Promise<void> {
		this.processingAnonymizeInvolvedParty = true;
		try{
			await involvedPartiesApi.anonymizeInvolvedParty(this.involvedPartyId);
		} catch (err) {
			console.error("Unable to Anonymize InvolvedParty:", err);
		}
		await this.loadInvolvedParties();
		this.resetEventRecords();
		this.isAnonymizationConfirmationVisible = false;
		this.processingAnonymizeInvolvedParty = false;
	}

	private async loadInvolvedParties(): Promise<void> {
		try {
			await this.loadInvolvedPartiesForEvent(this.eventId);
		} catch (err) {
			console.error("Unable to fetch Involved Parties for Event", err);
		}
	}
}
